import React, {Component} from 'react';
import {connect} from 'react-redux'
import {toggleLayout} from "../../../game/config/settings/actions";


const screen = window.screen

class OrientationComponent extends Component {
    changeOrientation = (o) => {
        if (this.props.orientation === 'auto') {
            this.props.dispatch(toggleLayout(o === 'portrait' ? 'vertical' : 'horizontal'))
        }

    }

    componentWillMount() {
        const onChangeOrientation = () => {
            const orientation = /^portrait/.test(screen.orientation.type) ? 'portrait' : 'landscape'
            this.changeOrientation(orientation)
        }
        if (screen.orientation) {
            screen.orientation.addEventListener('change', onChangeOrientation);
        } else {
            window.addEventListener('orientationchange', onChangeOrientation)
        }
    }

    componentWillUnmount() {
        if (screen.orientation) {
            screen.orientation.removeEventListener('change')
        } else {
            window.removeEventListener('orientationchange')
        }
    }

    render() {
        return this.props.children
    }
}

OrientationComponent.propTypes = {};
OrientationComponent.defaultProps = {};

export default connect((store) => {
    return {
        orientation: store.settings.orientation,
        layout: store.settings.layout
    }
})(OrientationComponent)




// WEBPACK FOOTER //
// ./src/shared/orientation/components/OrientationComponent.jsx